export const liveCaseIdFromAllocationCaseId = (caseId: string): string => {
  const id = String(caseId || "").trim();
  if (/^IR-\d+-\d+-/i.test(id)) return id.replace(/^IR-\d+-\d+-/i, "");
  if (/^IL-\d+-/i.test(id)) return id.replace(/^IL-\d+-/i, "");
  if (/^RD-\d+-/i.test(id)) return id.replace(/^RD-\d+-/i, "");
  if (/^IR-\d+-/i.test(id)) return id.replace(/^IR-\d+-/i, "");
  if (/^I[LR]-/i.test(id)) return id.slice(3);
  return id;
};

export const isClientRedesignCaseId = (caseId?: string | null): boolean =>
  /^RD-\d+-/i.test(String(caseId || "").trim());

export const isInternalRedesignCaseId = (caseId?: string | null): boolean =>
  /^IL-\d+-/i.test(String(caseId || "").trim()) ||
  /^IR-\d+-\d+-/i.test(String(caseId || "").trim()) ||
  /^IR-\d+-[A-Za-z]/i.test(String(caseId || "").trim());

export const caseHrefFromAllocationId = (caseId: string): string => {
  const liveId = liveCaseIdFromAllocationCaseId(caseId);
  const id = String(caseId || "").trim();
  if (isClientRedesignCaseId(id) || /^IR-\d+-/i.test(id)) {
    return `/dashboard/admin/cases/${liveId}?tab=redesign`;
  }
  return `/dashboard/admin/cases/${liveId}`;
};

/** Deep-link to the admin case Chat tab (live portal id). */
export const caseChatHrefFromAllocationId = (caseId: string): string => {
  const liveId = liveCaseIdFromAllocationCaseId(caseId);
  return `/dashboard/admin/cases/${liveId}?tab=chat`;
};

/** Live portal case (not client redesign / internal redesign). */
export const isLiveAllocationCaseId = (caseId?: string | null): boolean => {
  const id = String(caseId || "").trim();
  if (!id) return false;
  return !isClientRedesignCaseId(id) && !isInternalRedesignCaseId(id);
};
